import workTask from './common/workTask';
import Enum from './common/enum';

const namespaced = true;

export default{
    namespaced,
    ...workTask,
    modules: {
        namespaced,
        Enum,
    }
}